<!--
 * @Author: pengyong
 * @Date: 2020-11-15 23:17:00
 * @LastEditors: pengyong
 * @LastEditTime: 2020-11-17 00:00:52
 * @Description: 找回密码
 * @FilePath: /exhibit/src/views/forget/index.vue
-->
<template>
    <Wrapper :modalWidth="modalWidth" :modalHeight="modalHeight">
        <div class="forget-wrapper">
            <img @click="handleBack" v-if="step !== 3" :src="require('@/assets/back.png')" alt="" class="back" />
            <div class="step1" v-if="step === 1">
                <div class="title">{{ $t("forget").title }}</div>
                <div @click="handleChoose('phone')" :class="['btn', type === 'phone' && 'current']">{{ $t("forget").byEmail }}</div>
                <div @click="handleChoose('email')" :class="['btn', type === 'email' && 'current']">{{ $t("forget").byPhone }}</div>
            </div>
            <div class="step2" v-if="step === 2">
                <div class="title">{{ $t("forget").title2 }}</div>
                <div class="form">
                    <div class="form-item">
                        <input v-model="phone" class="ipt" type="text" :placeholder="$t('forget').phonePlaceHolder" />
                    </div>
                    <div class="form-item form-item-code">
                        <div class="form-item-left">
                            <div class="prefix prefix-code">
                                <img :src="require('@/assets/code.png')" alt="" />
                            </div>
                            <input
                                class="ipt"
                                maxlength="6"
                                v-model="phoneCode"
                                v-if="type === 'phone'"
                                :placeholder="$t('login').codePlaceholder"
                                type="text"
                            />
                            <input class="ipt" maxlength="6" v-else v-model="emailCode" :placeholder="$t('login').codePlaceholder" type="text" />
                        </div>
                        <div :class="['form-item-right', disabledSendCode && 'disabled']" @click="handleGetCode">
                            {{ hasSend ? count : $t("login").sendCode }}
                        </div>
                    </div>
                    <div class="form-item">
                        <input v-model="password" class="ipt" type="text" :placeholder="$t('forget').pswPlaceHolder" />
                    </div>
                    <div class="form-item">
                        <input v-model="newPassword" class="ipt" type="text" :placeholder="$t('forget').newPswPlaceHolder" />
                    </div>
                    <CommonButton @click="handleSubmit" :loading="loading" style="margin-bottom:13px;" :disabled="disabled">
                        {{ $t("forget").submit }}
                    </CommonButton>
                </div>
            </div>
            <div class="step3" v-if="step === 3">
                <div class="title">{{ $t("forget").title3 }}</div>
                <div class="success-title">{{ $t("forget").successTitle }}</div>
                <div class="success-desc">{{ $t("forget").successDesc }}</div>
                <div class="complete" @click="$router.go(-1)">{{ $t("forget").complete }}</div>
            </div>
        </div>
    </Wrapper>
</template>

<script>
import Wrapper from "@/components/CommonWrapper";
import CommonButton from "@/components/CommonButton";
import api from "@/api";

export default {
    components: {
        Wrapper,
        CommonButton
    },
    data() {
        return {
            step: 1,
            type: "", // phone 手机号  email 邮箱
            phone: "",
            phoneCode: "",
            emailCode: "",
            hasSend: false,
            count: 60,
            password: "",
            newPassword: "",
            loading: false
        };
    },
    computed: {
        disabled() {
            let pass = null;
            if (this.type === "phone") {
                pass = !!(this.email && this.emailCode);
            } else {
                pass = !!(this.phone && this.phoneCode);
            }
            return !(pass && this.password && this.newPassword);
        },
        disabledSendCode() {
            if (this.type === "phone" && !this.phone) {
                return true;
            }
            if (this.type === "email" && !this.email) {
                return true;
            }
            return this.hasSend;
        },
        modalWidth() {
            return this.step === 1 ? 467 : 467;
        },
        modalHeight() {
            return this.step === 2 ? 453 : 400;
        }
    },
    methods: {
        async handleGetCode() {
            if (this.disabledSendCode) return;
            this.hasSend = true;
            let res = {};
            if (this.current === 1) {
                res = await api.sendSmsCode({ phone: this.phone });
            } else {
                res = await api.sendEmailCode({ email: this.email });
            }
            if (res.res === 1) {
                this.count = 60;
                clearInterval(this.timer);
                this.startTime = new Date().getTime();
                this.timer = setInterval(() => {
                    let countDownTime = Math.round(60 - (new Date().getTime() - this.startTime) / 1000);
                    if (countDownTime <= 0) {
                        this.hasSend = false;
                        this.count = 60;
                        clearInterval(this.timer);
                    } else {
                        this.count = countDownTime;
                    }
                }, 1000);
            } else {
                this.hasSend = false;
                this.count = 60;
                clearInterval(this.timer);
                this.$message.error(res.message);
            }
        },
        handleChoose(type) {
            this.type = type;
            this.step = 2;
        },
        handleBack() {
            if (this.step === 1) {
                this.$router.go(-1);
            } else {
                this.step = this.step - 1;
            }
            this.loading = false;
        },
        handleSubmit() {}
    }
};
</script>

<style lang="scss" scoped>
.forget-wrapper {
    position: relative;
    overflow: hidden;
    .back {
        width: 27px;
        height: 27px;
        position: absolute;
        left: 13px;
        top: 13px;
        cursor: pointer;
    }
    .step1 {
        .title {
            text-align: center;
            height: 28px;
            font-size: 20px;
            font-weight: 500;
            color: #5f7185;
            line-height: 28px;
            margin: 53px 0 67px;
        }
        .btn {
            width: 333px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #dfe8f9;
            box-shadow: 1px 3px 4px 0px rgba(0, 0, 0, 0.2), -1px -3px 4px 0px rgba(255, 255, 255, 0.4), 0px 0px 4px 3px rgba(255, 255, 255, 0.1);
            border-radius: 13px;
            font-size: 16px;
            color: #5f7185;
            margin: 0 auto 27px;
            cursor: pointer;
            &.current {
                background: #226eff;
                color: #fff;
                box-shadow: 1px 3px 4px 0px rgba(0, 0, 0, 0.2), -1px -3px 4px 0px rgba(255, 255, 255, 0.4), 0px 0px 4px 3px rgba(255, 255, 255, 0.1);
            }
        }
    }
    .step2 {
        padding: 0 67px;
        .title {
            text-align: center;
            height: 28px;
            font-size: 20px;
            font-weight: 500;
            color: #5f7185;
            line-height: 28px;
            margin: 53px 0 33px;
        }
        .form {
            .form-item {
                height: 40px;
                background: #dfe8f9;
                box-shadow: 1px 3px 4px 0px rgba(0, 0, 0, 0.2), -1px -3px 4px 0px rgba(255, 255, 255, 0.4), 0px 0px 4px 3px rgba(255, 255, 255, 0.1);
                border-radius: 13px;
                margin-bottom: 20px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                overflow: hidden;
                .prefix,
                .suffix {
                    width: 43px;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-shrink: 0;
                }
                .prefix-account {
                    img {
                        width: 16px;
                        height: 16px;
                    }
                }
                .prefix-psw {
                    img {
                        width: 13px;
                        height: 16px;
                    }
                }
                .prefix-code {
                    img {
                        width: 16px;
                        height: 19px;
                    }
                }
                .ipt {
                    height: 40px;
                    line-height: 40px;
                    flex: 1;
                    background: transparent;
                    font-size: 16px;
                    padding: 0 15px;
                    color: #5f7185;
                }
                .eye-hide {
                    width: 16px;
                    height: 7px;
                    cursor: pointer;
                }
                .eye {
                    width: 16px;
                    height: 12px;
                    cursor: pointer;
                }
            }
            .form-item-code {
                background: transparent;
                border-radius: none;
                box-shadow: none;
                overflow: inherit;
                .form-item-left {
                    width: 200px;
                    background: #dfe8f9;
                    box-shadow: 1px 3px 4px 0px rgba(0, 0, 0, 0.2), -1px -3px 4px 0px rgba(255, 255, 255, 0.4),
                        0px 0px 4px 3px rgba(255, 255, 255, 0.1);
                    border-radius: 13px;
                    display: flex;
                    align-items: center;
                    input {
                        padding: 0;
                    }
                }
                .form-item-right {
                    width: 113px;
                    height: 40px;
                    line-height: 40px;
                    background: #226eff;
                    box-shadow: 1px 3px 4px 0px rgba(0, 0, 0, 0.2), -1px -3px 4px 0px rgba(255, 255, 255, 0.4),
                        0px 0px 4px 3px rgba(255, 255, 255, 0.1);
                    border-radius: 13px;
                    text-align: center;
                    font-size: 16px;
                    color: #ffffff;
                    cursor: pointer;
                    &.disabled {
                        cursor: not-allowed;
                        background: #a4c3ff;
                        box-shadow: 1px 3px 4px 0px rgba(0, 0, 0, 0.2), -1px -3px 4px 0px rgba(255, 255, 255, 0.4),
                            0px 0px 4px 3px rgba(255, 255, 255, 0.1);
                    }
                }
            }
        }
    }
    .step3 {
        padding: 0 67px;
        .title {
            text-align: center;
            height: 28px;
            font-size: 20px;
            font-weight: 500;
            color: #5f7185;
            line-height: 28px;
            margin: 53px 0 42px;
        }
        .success-title {
            font-size: 16px;
            font-weight: 500;
            color: #5f7185;
            line-height: 22px;
            margin-bottom: 20px;
        }
        .success-desc {
            font-size: 12px;
            color: #5f7185;
            line-height: 24px;
        }
        .complete {
            margin-top: 40px;
            width: 333px;
            height: 40px;
            line-height: 40px;
            background: #226eff;
            box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.3);
            border-radius: 20px;
            color: #fff;
            font-size: 16px;
            text-align: center;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/forget/index.vue